<style lang="sass">
.page-top
  text-align: center
  background-color: var(--navigation-background-color)
  padding-top: 0 !important
  padding-bottom: 0 !important
.page-bottom
  background: linear-gradient(to bottom, var(--blue) 100px, var(--light-gray) 50.0001px)
.code-input
  text-align: center
.extra-link
  text-align: center
  padding: 1rem 0.5rem
</style>
<template>
  <div class="page">
    <div class="padded page-top">
      <span class="font-style-1">
        Enter the {{codeLength}} digit code emailed to:
      </span>
    </div>
    <div class="padded page-bottom">
      <form @submit.prevent="attemptUserConfirmation">
        <div v-if="errors.length">
          <div v-for="(error,i) in errors" :key="i">{{error}}</div>
        </div>
        <div class="input-group">
          <label>EMAIL</label>
          <input type="email" placeholder="Email" v-model="email" v-if="!givenEmail" class="input-control">
          <input type="email" v-model="email" disabled="true" v-if="givenEmail" class="input-control">
        </div>
        <div class="input-group">
          <label>CODE</label>
          <input
              class="code-input input-control"
              type="number"
              placeholder="XXXXX"
              v-model="code"
              v-on:input="handleInput({target: $event.target})"
              autocapitalize="none"
              >
        </div>
        <div>
          <input type="submit" value="Confirm" class="button positive">
        </div>
      </form>
      <div class="extra-link">
        <router-link :to="{name: 'resendUserConfirmation'}">Re-send confirmation email?</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'ConfirmUser',
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftImg: 'icon-back.svg', leftRoute: {name: 'welcome'}, centerEnabled: false});
    this.assignParamsData();
  },
  data() {
    return {
      errors:     [],
      givenEmail: false,
      email:      null,
      code:       '',
      codeLength: 5
    };
  },
  computed: {
    emailVerification() {
      return this.code.length === this.codeLength ?
        this.code :
        null;
    }
  },
  watch: {
    '$route': 'assignParamsData',
    emailVerification: function() {
      if (this.emailVerification) {
        this.attemptUserConfirmation();
      }
    }
  },
  methods: {
    assignParamsData() {
      if (this.$route.params.email) {
        this.givenEmail = true;
        this.email = this.$route.params.email;
      }
      if (!!this.$route.params.emailVerification && this.$route.params.emailVerification.length === this.codeLength) {
        this.code = this.$route.params.emailVerification;
      }
    },
    handleInput({target}) {
      if (target.value.length === this.codeLength) {
        this.code = target.value;
      }
    },
    attemptUserConfirmation() {
      api.UserConfirmation.destroy({params: {userConfirmation: {email: this.email, email_verification: this.emailVerification}}})
        .then(userAuth => {
          this.$store.commit('logIn', userAuth);
          this.$router.push({name: 'dashboard'});
        }).catch(({response: {data: {errors}}}) => {
          this.success = false;
          this.errors = errors;
        })
    }
  }
};
</script>
